document.addEventListener("DOMContentLoaded", function () {

  // TRIGGER → TARGET(S)
  const sectionMap = {
    "shopify-section-template--29224020213841__rhea_kapoor_section_2_LfJajw": [
      "shopify-section-template--29224020213841__rhea_kapoor_section_1_rQMaBT"
    ],

    "shopify-section-template--29224020213841__rhea_kapoor_section_4_HkeaW9": [
      "shopify-section-template--29224020213841__rhea_kapoor_section_3_y7Q3P4",
      "shopify-section-template--29224020213841__rhea_kapoor_section_2_LfJajw"
    ],

    "shopify-section-template--29224020213841__rhea_kapoor_section_5_h7tCnn": [
      "shopify-section-template--29224020213841__rhea_kapoor_section_4_HkeaW9"
    ],

    "shopify-section-template--29224020213841__1765169824ba0a27bb": [
      "shopify-section-template--29224020213841__rhea_kapoor_section_5_h7tCnn"
    ],


    "shopify-section-template--29224020213841__rhea_kapoor_section_4_6kpj9G": [
      "shopify-section-template--29224020213841__rhea_kapoor_section_7_iLaceT"
    ],

    "shopify-section-template--29224020213841__reha_kapoor_section_7_6EUCqn": [
      "shopify-section-template--29224020213841__rhea_kapoor_section_2_LfJajw",
      "shopify-section-template--29224020213841__rhea_kapoor_section_3_y7Q3P4",
      "shopify-section-template--29224020213841__rhea_kapoor_section_4_HkeaW9",
      "shopify-section-template--29224020213841__rhea_kapoor_section_5_h7tCnn",
      "shopify-section-template--29224020213841__1765169824ba0a27bb",
      "shopify-section-template--29224020213841__rhea_kapoor_section_4_6kpj9G",
      "shopify-section-template--29224020213841__rhea_kapoor_section_7_iLaceT"
    ],
    "shopify-section-sections--25484700221803__footer":[
      "shopify-section-template--29224020213841__rhea_kapoor_section_2_LfJajw",
      "shopify-section-template--29224020213841__rhea_kapoor_section_3_y7Q3P4",
      "shopify-section-template--29224020213841__rhea_kapoor_section_4_HkeaW9",
      "shopify-section-template--29224020213841__rhea_kapoor_section_5_h7tCnn",
      "shopify-section-template--29224020213841__1765169824ba0a27bb",
      "shopify-section-template--29224020213841__rhea_kapoor_section_4_6kpj9G",
      "shopify-section-template--29224020213841__rhea_kapoor_section_7_iLaceT"
    ]
  };


  // Create observer
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const targets = sectionMap[entry.target.id];
        if (!targets) return;

        targets.forEach((targetId) => {
          const el = document.getElementById(targetId);
          if (!el) return;

          if (entry.intersectionRatio >= 0.5) {
            el.classList.add("myAnimation");
          } else {
            el.classList.remove("myAnimation");
          }
        });
      });
    },
    { threshold: 0.5 }
  );


  // Attach observer to all trigger sections
  Object.keys(sectionMap).forEach((id) => {
    const el = document.getElementById(id);
    if (el) observer.observe(el);
  });

});


document.addEventListener("DOMContentLoaded", function () {

  const triggerId = "shopify-section-template--29224020213841__rhea_kapoor_section_4_HkeaW9";
  const targetId  = "shopify-section-template--29224020213841__rhea_kapoor_section_4_HkeaW9";

  const trigger = document.getElementById(triggerId);
  const target = document.getElementById(targetId);

  if (!trigger || !target) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio >= 0.3) {
          target.classList.add("zoom-animation");
        } else {
          target.classList.remove("zoom-animation");
        }
      });
    },
    { threshold: 0.3 }
  );

  observer.observe(trigger);
});


document.addEventListener("DOMContentLoaded", function () {

  const triggerId = "shopify-section-template--29224020213841__rhea_kapoor_section_4_6kpj9G";
  const targetId  = "shopify-section-template--29224020213841__rhea_kapoor_section_4_6kpj9G";

  const trigger = document.getElementById(triggerId);
  const target = document.getElementById(targetId);

  if (!trigger || !target) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio >= 0.3) {
          target.classList.add("zoom-animation");
        } else {
          target.classList.remove("zoom-animation");
        }
      });
    },
    { threshold: 0.3 }
  );

  observer.observe(trigger);
});


document.addEventListener("DOMContentLoaded", function () {

  const triggerId = "shopify-section-template--29224020213841__rhea_kapoor_section_5_h7tCnn";
  const targetId  = "shopify-section-template--29224020213841__rhea_kapoor_section_5_h7tCnn";

  const trigger = document.getElementById(triggerId);
  const target = document.getElementById(targetId);

  if (!trigger || !target) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio >= 0.3) {
          target.classList.add("side-animation");
        } else {
          target.classList.remove("side-animation");
        }
      });
    },
    { threshold: 0.3 }
  );

  observer.observe(trigger);
});


// video sound play 

// (function() {
//   console.log('🎵 Video audio control loaded');
  
//   let isMuted = true;
//   let autoUnmuted = false;
  
//   // Get only the VISIBLE video (desktop OR mobile, not both)
//   const getVisibleVideo = () => {
//     const videos = document.querySelectorAll('.banner-video');
    
//     for (let video of videos) {
//       const style = window.getComputedStyle(video);
//       if (style.display !== 'none' && style.visibility !== 'hidden') {
//         return video;
//       }
//     }
//     return null;
//   };
  
//   // Ensure ALL videos are playing (muted for autoplay)
//   const ensureAllVideosPlay = () => {
//     const allVideos = document.querySelectorAll('.banner-video');
    
//     if (allVideos.length === 0) {
//       console.warn('❌ No videos found');
//       return;
//     }
    
//     allVideos.forEach((video, i) => {
//       video.muted = true; // Must be muted for autoplay
      
//       video.play().then(() => {
//         console.log(`✅ Video ${i} playing (muted)`);
//       }).catch(err => {
//         console.error(`❌ Video ${i} autoplay failed:`, err.message);
        
//         // Retry once
//         setTimeout(() => {
//           video.play().catch(e => console.error(`Retry failed for video ${i}:`, e.message));
//         }, 500);
//       });
//     });
//   };
  
//   // Mute ALL videos except the visible one
//   const muteAllExcept = (activeVideo) => {
//     const allVideos = document.querySelectorAll('.banner-video');
//     allVideos.forEach(video => {
//       if (video !== activeVideo) {
//         video.muted = true;
//       }
//     });
//   };
  
//   // Unmute visible video only
//   const unmuteVisibleVideo = () => {
//     const visibleVideo = getVisibleVideo();
    
//     if (!visibleVideo) {
//       console.warn('❌ No visible video found');
//       return;
//     }
    
//     console.log('🔊 Unmuting visible video...');
    
//     // Mute all others first
//     muteAllExcept(visibleVideo);
    
//     // Then unmute the visible one
//     visibleVideo.muted = false;
//     visibleVideo.play().then(() => {
//       console.log('✅ Video unmuted successfully');
//     }).catch(err => {
//       console.error('❌ Unmute failed:', err.message);
//     });
    
//     isMuted = false;
//     updateButtonState();
//   };
  
//   // Mute visible video
//   const muteVisibleVideo = () => {
//     const visibleVideo = getVisibleVideo();
    
//     if (!visibleVideo) return;
    
//     console.log('🔇 Muting video...');
//     visibleVideo.muted = true;
    
//     isMuted = true;
//     updateButtonState();
//   };
  
//   // Update button icon
//   const updateButtonState = () => {
//     const unmuteBtn = document.querySelector('.video-unmute-btn');
//     if (!unmuteBtn) return;
    
//     const mutedIcon = unmuteBtn.querySelector('.icon-muted');
//     const unmutedIcon = unmuteBtn.querySelector('.icon-unmuted');
    
//     if (isMuted) {
//       mutedIcon.style.display = 'block';
//       unmutedIcon.style.display = 'none';
//       unmuteBtn.setAttribute('aria-label', 'Unmute video');
//     } else {
//       mutedIcon.style.display = 'none';
//       unmutedIcon.style.display = 'block';
//       unmuteBtn.setAttribute('aria-label', 'Mute video');
//     }
//   };
  
//   // Auto-unmute on first user interaction
//   const handleFirstInteraction = () => {
//     if (autoUnmuted) return;
    
//     autoUnmuted = true;
//     unmuteVisibleVideo();
    
//     console.log('✅ Auto-unmuted on user interaction');
    
//     // Remove listeners
//     document.removeEventListener('click', handleFirstInteraction);
//     document.removeEventListener('touchstart', handleFirstInteraction);
//     document.removeEventListener('scroll', handleFirstInteraction);
//     document.removeEventListener('keydown', handleFirstInteraction);
//   };
  
//   // Initialize function
//   const init = () => {
//     console.log('🚀 Initializing video controls...');
    
//     const unmuteBtn = document.querySelector('.video-unmute-btn');
    
//     if (!unmuteBtn) {
//       console.warn('❌ No unmute button found, retrying in 500ms...');
//       setTimeout(init, 500);
//       return;
//     }
    
//     // Listen for user interactions (auto-unmute)
//     document.addEventListener('click', handleFirstInteraction, { passive: true, once: true });
//     document.addEventListener('touchstart', handleFirstInteraction, { passive: true, once: true });
//     document.addEventListener('scroll', handleFirstInteraction, { passive: true, once: true });
//     document.addEventListener('keydown', handleFirstInteraction, { passive: true, once: true });
    
//     console.log('👂 Waiting for interaction to auto-unmute...');
    
//     // Manual button click
//     unmuteBtn.addEventListener('click', (e) => {
//       e.stopPropagation();
      
//       if (isMuted) {
//         unmuteVisibleVideo();
//         autoUnmuted = true;
//       } else {
//         muteVisibleVideo();
//       }
//     });
    
//     // Handle window resize (desktop/mobile switch)
//     let resizeTimeout;
//     window.addEventListener('resize', () => {
//       clearTimeout(resizeTimeout);
//       resizeTimeout = setTimeout(() => {
//         if (!isMuted) {
//           unmuteVisibleVideo();
//         }
//       }, 200);
//     });
    
//     // IMPORTANT: Start playing all videos (muted)
//     ensureAllVideosPlay();
//   };
  
//   // Start when DOM is ready
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }
  
// })();


document.addEventListener('DOMContentLoaded', () => {
  const videos = document.querySelectorAll('.banner-video');
  const unmuteBtn = document.querySelector('.video-unmute-btn');
  
  if (!unmuteBtn || videos.length === 0) return;
  
  let isMuted = true;
  
  unmuteBtn.addEventListener('click', () => {
    isMuted = !isMuted;
    
    videos.forEach(video => {
      video.muted = isMuted;
    });
    
    // Icon toggle
    const mutedIcon = unmuteBtn.querySelector('.icon-muted');
    const unmutedIcon = unmuteBtn.querySelector('.icon-unmuted');
    
    if (isMuted) {
      mutedIcon.style.display = 'block';
      unmutedIcon.style.display = 'none';
    } else {
      mutedIcon.style.display = 'none';
      unmutedIcon.style.display = 'block';
    }
  });
});


